module.exports = "/assets/e12f946265550d8b968e329939e49595.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SV.png
// module id = 1835
// module chunks = 0